
import React, { useState, useMemo, useCallback, useRef } from "react";
import Grid from "@mui/material/Grid2";
import Box from "@mui/material/Box";
import { useSelector } from "react-redux";
import ZoneTablePanel from "./ZoneTablePanel";
import ShapesTablePanel from "./ShapesTablePanel";
import MapDisplay from "./MapDisplay";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import TopControlPanel from "./TopControlPanel";
import GLBDropzoneModal from "./GLBDropzoneModal";
import { FormControl, InputLabel, MenuItem, Select } from "@mui/material";

const ConfigureFacilityLayout = () => {
  const facility = useSelector((state) => state.organization.activeFacility);

  const mapRef = useRef(null);

const initLayoutData = useMemo(
    () =>
      facility?.propertiesMap?.layoutData || {
        zones: [],
        geofences: [],
        facilityOutlines: [],
        floorPlans: []
      },
    [facility]
  );

  const [mode, setMode] = useState("none");
  const [shapeType, setShapeType] = useState("zone");
  const [shapeName, setShapeName] = useState("");
  const [glbUploadModalOpen, setGlbUploadModalOpen] = useState(false);
  const [uploadedGlbUrl, setUploadedGlbUrl] = useState(null);
  const [layoutData, setLayoutData] = useState(initLayoutData);
  console.log("layoutData in ConfigureFacilityLayout:", layoutData);

  const [showShapeModal, setShowShapeModal] = useState(false);
  
  const [editModalOpen, setEditModalOpen] = useState(false);
  const [selectedShapeForEdit, setSelectedShapeForEdit] = useState(null);

  const handleShapeEditInitiated = (shapeData) => {
    setSelectedShapeForEdit(shapeData);
    setEditModalOpen(true);
  };

  const handleEditSave = () => {
    if (onShapeEditConfirmedRef.current && selectedShapeForEdit) {
      onShapeEditConfirmedRef.current({ id: selectedShapeForEdit.id, name: selectedShapeForEdit.name });
    }
    setEditModalOpen(false);
    setSelectedShapeForEdit(null);
  };

  const handleEditCancel = () => {
    setEditModalOpen(false);
    setSelectedShapeForEdit(null);
  };

  const onShapeEditConfirmedRef = useRef(null);

  const registerEditConfirmHandler = (handler) => {
    onShapeEditConfirmedRef.current = handler;
  };


const handleModalInfoSubmit = () => {
  if(shapeName && shapeType) {
    setShowShapeModal(false);
    }
  
  };

  const handleShapeDrawn = useCallback((shapeData) => {
    //use shapeData to set layoutData and show the shape modal and reset shape name
    setLayoutData((prev) => {
      const updated = { ...prev };
      if (shapeData?.type === 'zone') {
        updated.zones = [...updated.zones, { ...shapeData }];
      } else if (shapeData?.type === 'geofence') {
        updated.geofences = [...updated.geofences, { ...shapeData }];
      } else if (shapeData?.type === 'outline') {
        updated.facilityOutlines = [...updated.facilityOutlines, { ...shapeData }];
      }
      return updated;
    });
    setShapeName(''); // Reset shape name after drawing
    setShowShapeModal(true); // Show the shape modal
  }, []);


  const [openDrawModal, setOpenDrawModal] = useState(false);

  const handleFileUpload = (file) => {
    const url = URL.createObjectURL(file);
    setUploadedGlbUrl(url);
  };

  return (
    <Grid container direction="column" sx={{ height: "100%" }}>
      {/* Top bar with controls */}
      <Grid item size={12} sx={{ padding: 2, 
         marginBottom: "50px", height: "50px" }}>
        <Box display="flex" justifyContent="space-between">
          <TopControlPanel
            mode={mode}
            setMode={(val) => {
              setMode(val);
              if (val === "draw") {setShowShapeModal(true);} 
            }}
            shapeType={shapeType}
            setShapeType={setShapeType}
            openGlbModal={() => setGlbUploadModalOpen(true)}
          />
        </Box>
      </Grid>

      {/* Bottom section (map and table split) */}
      <Grid item size={12}>
        <Grid container sx={{ 
            height: "74vh",
            bachground: "pink"
        }}>
          {/* Map area */}
          <Grid item size={7} sx={{ 
                height: "74vh",
            }}>
              <MapDisplay
                 ref={mapRef}
                 mode={mode}
                 shapeType={shapeType}
                 shapeName={shapeName}
                 layoutData={layoutData}
                 setLayoutData={setLayoutData}
                 onShapeDrawn={handleShapeDrawn}
                 onShapeEditInitiated={handleShapeEditInitiated}
                 onShapeEditConfirmed={registerEditConfirmHandler}
              />
          </Grid>

          {/* Sidebar */}
          <Grid item size={5} sx={{ 
                height: "80vh", 
                overflowY: "auto", 
                borderLeft: "1px solid #ccc",
                display: "flex",
              flexDirection: "column",
              padding: "0 8px", 
            }}>
              <ZoneTablePanel shapeType={shapeType} zones={layoutData.zones} />
              <ShapesTablePanel
                shapeType={shapeType}
                shapes={[
                  ...layoutData.geofences,
                  ...layoutData.facilityOutlines,
                  ...layoutData.floorPlans
                ]}
              />
          </Grid>
        </Grid>
      </Grid>

        <Dialog open={showShapeModal} onClose={() => setShowShapeModal(false)}>
        <DialogTitle>Set Shape Details</DialogTitle>
        <DialogContent>
          <FormControl fullWidth margin="dense">
            <InputLabel>Shape Type</InputLabel>
            <Select
              value={shapeType}
              onChange={(e) => setShapeType(e.target.value)}
              label="Shape Type"
            >
              <MenuItem value="zone">Zone</MenuItem>
              <MenuItem value="geofence">Geofence</MenuItem>
              <MenuItem value="outline">Facility Outline</MenuItem>
            </Select>
          </FormControl>
          <TextField
            autoFocus
            margin="dense"
            label="Shape Name"
            fullWidth
            value={shapeName}
            onChange={(e) => setShapeName(e.target.value)}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => {
            setShowShapeModal(false)
            setShapeName(''); // Reset shape name when closing
            // switch to edit mode
            // setShapeType(null);
            setMode('edit');
          }}>Cancel</Button>
          <Button onClick={handleModalInfoSubmit} variant="contained">Submit</Button>
        </DialogActions>
      </Dialog>

      <Dialog open={editModalOpen} onClose={handleEditCancel}>
        <DialogTitle>Edit Shape</DialogTitle>
        <DialogContent>
          <TextField
            fullWidth
            label="Shape Name"
            value={selectedShapeForEdit?.name || ""}
            onChange={(e) => setSelectedShapeForEdit({ ...selectedShapeForEdit, name: e.target.value })}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleEditCancel}>Cancel</Button>
          <Button variant="contained" onClick={handleEditSave}>Save Changes</Button>
        </DialogActions>
      </Dialog>

      {/* GLB Upload Modal */}
      <GLBDropzoneModal
        open={glbUploadModalOpen}
        onClose={() => setGlbUploadModalOpen(false)}
        onFileUpload={handleFileUpload}
      />
    </Grid>
  );
};

export default ConfigureFacilityLayout;
